import { gql } from "@apollo/client";

export const CREATE_CATEGORY = gql`
  mutation CreateCategoryMutation($input: CreateCategoryInput!) {
    createCategory(input: $input) {
      ok
      error
      id
    }
  }
`;

export const UPDATE_CATEGORY = gql`
  mutation UpdateCategoryMutation($id: Int!, $input: UpdateCategoryInput!) {
    updateCategory(id: $id, input: $input) {
      ok
      error
    }
  }
`;

export const REMOVE_CATEGORY = gql`
  mutation RemoveCategoryMutation($id: Int!) {
    removeCategory(id: $id) {
      ok
      error
    }
  }
`;

export const CATEGORY = gql`
  query CategoryQuery($id: Int!) {
    category(id: $id) {
      ok
      error
      result {
        id
        name
        sitesCount
      }
    }
  }
`;

export const CATEGORIES = gql`
  query CategoriesQuery {
    categories {
      ok
      error
      total
      results {
        id
        name
        sitesCount
      }
    }
  }
`;
